import ActionCreator from "../actionCreator";

export default {
    getSidelinks: ActionCreator("GET_SIDELINKS"),
    createSidelinks: ActionCreator("CREATE_SIDELINKS"),
    errorResponse: ActionCreator("ERROR_RESPONSE_SIDELINKS"),
};
